import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiInstance from '@/utils/api'

export interface PUMOrder {
  id: number
  order_no: string
}

export type PlaybackType = 'video' | 'image'

export const usePUMOrderStore = defineStore('pumOrder', () => {
  const preparationOrders = ref<PUMOrder[]>([])
  const readyOrders = ref<PUMOrder[]>([])
  const displayScale = ref<number>(1)
  const enablePlayback = ref<boolean>(false)
  const playbackType = ref<PlaybackType>('video')
  const slideDuration = ref<number>(5)
  const pickupMonitorMedia = ref<string[]>([])

  const fetchOrders = async (
    params: { slug: string; accountName: string },
    signal?: AbortSignal
  ) => {
    return await apiInstance.get(`/pum/${params.slug}/${params.accountName}`, { signal })
  }

  const reset = () => {
    preparationOrders.value = []
    readyOrders.value = []
    displayScale.value = 1
    enablePlayback.value = false
    playbackType.value = 'video'
    slideDuration.value = 5
    pickupMonitorMedia.value = []
  }

  return {
    preparationOrders,
    readyOrders,
    displayScale,
    enablePlayback,
    playbackType,
    slideDuration,
    pickupMonitorMedia,
    fetchOrders,
    reset,
  }
})
